<template>
  <div class="aboutUs-page">
    <banner>
      探索技术深井&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打造核心价值&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;砥砺前行不惰<br/>
      勇攀民生服务高峰
    </banner>

    <div class="panel-main">
      <div class="panel-content">
        <ul class="information">
          <li>
            <router-link :to="{name: 'News'}">
              <img :src="news.coverUrl" alt="资讯中心">
              <div class="text-bg">
                <h3>资讯中心</h3>
                <p>INFORMATION CENTER</p>
                <i>×</i>
                <p class="public-text">
                  {{news.summary}}
                </p>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'CompanyProfile'}">
              <img src="../../static/images/abouts/company-info.jpg" alt="公司介绍">
              <div class="text-bg">
                <h3>公司介绍</h3>
                <p>COMPANY INFORMATION</p>
                <i>×</i>
                <p class="public-text">
                  北京一维大成科技有限公司（简称“一维科技”）成立于2002年，致力于政府民生工程领域的信息化建设。是一家以生物认证和人工智能为技术核心，以大数据分析为支撑，以民生业务为载体的创新型公共服务提供商。
                </p>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'JoinUs'}">
              <img src="../../static/images/abouts/join-us.png" alt="">
              <div class="text-bg">
                <h3>加入我们</h3>
                <p>JOIN US</p>
                <i>×</i>
                <p class="public-text">
                  如果你有创新的勇气和智慧，你渴望有生命力的团队文化，那么请加入我们。在这里，你从事的不仅仅是一份赖以生存的工作，而是一个改变你职业生涯的事业，一个拓展你人生高度的平台。
                </p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import fetch from '../server/index';
  import Banner from '../components/Banner'

  export default {
    data () {
      return {
        news: {
          summary: '正在抓取资讯',
          coverUrl: require('../../static/images/abouts/info-center.jpg')
        }
      }
    },
    methods: {
      //      获取资讯列表
      getList () {
        fetch('/api/policyInfo/list', {
          pageNumber: 1,
          pageSize: 1,
          year: new Date().getFullYear()
        }).then(res => {
          if (res.rows.length < 1) {
            return false;
          }
          this.news = res.rows[0];
          this.news.coverUrl = window.config.host + this.news.coverUrl;
        }, err => {
          console.log(err)
        }).catch(e => {})
      }
    },
    components: {
      Banner
    },
    mounted () {
      this.getList();
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .aboutUs-page {
    background: #f5f5f5;
    $theme-color: #00ccff;
    width: 100%;
    height: 100%;
    .pulic-banner-container {
      background-image: url('../assets/images/banners/bg-abouts.jpg');
      .banner-content .banner-txt {
        font-size: 30px;
        line-height: 1.5em;
      }
    }
    .information {
      padding: 142px 0 100px;
      @include clear();
      margin-left: -22px;
      margin-right: -22px;
      li {
        width: 33.3%;
        font-style: normal;
        position: relative;
        float: left;
        margin-top: 66px;
        border-radius: 2px;
        a {
          display: block;
          padding-left: 22px;
          padding-right: 22px;
        }
        img {
          width: 337px;
          height: 244px;
          margin: -66px auto 0;
          display: block;
          border-radius: 2px;
          overflow: hidden;
        }
        .text-bg {
          color: #3b3b3b;
          i {
            display: block;
            font-size: 16px;
            line-height: 40px;
            color: #656565;
          }
          h3 {
            font-size: 22px;
            line-height: 40px;
            font-weight: 600;
            margin-top: 32px;
          }
          h3, p, i {
            text-align: center;
          }
          p {
            font-size: 16px;
            color: #888888;
            line-height: 26px;
          }
          .public-text {
            text-align: left;
            font-size: 14px;
            color: #3b3b3b;
            /*width: 260px;*/
            margin: 0 auto;
            padding: 0 15px;
            margin-bottom: 30px;
            height: 125px;
            position:relative;
            overflow: hidden;
          }
        }
        &:first-child{
          .public-text:after {
              content:"...";
              font-weight:bold;
              position:absolute;
              bottom:0;
              right: 1em;
              padding: 0 10px;
              background: linear-gradient(to right, transparent , #f5f5f5 40%);
          }
        }
        &:hover {
          transition: .2s;
          background: #ebecef;
          img {
            margin-top: -82px;
            transition: .2s;
          }
          .arrow-right {
            display: block;
          }
          p {
            line-height: 26px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pc/AboutUs.vue